import {Component, ReactNode} from 'react';
import {t} from '../common/getTranslations';
import {requestContext} from '../common/requestContext';
import {ApiStatusCodeVo} from '../common/shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {Text} from '../design-system/atoms/Text/Text';
import {ErrorArea} from '../design-system/organisms/ErrorArea/ErrorArea';
import {getSerializedPagewebError} from './getSerializedPagewebError.function';

interface Props {
  children: ReactNode;
}

interface State {
  /**
   * rethrow 할 에러
   */
  error?: Error;
}

export class ContentPreviewErrorBoundary extends Component<Props, State> {
  public state: State = {
    error: undefined,
  };

  public static getDerivedStateFromError(error: Error): State {
    return {
      error,
    };
  }

  public render() {
    const {isMobile} = requestContext.requestInfo.display;

    if (!this.state.error) {
      return this.props.children;
    }

    const serializedPagewebError = getSerializedPagewebError(this.state.error);

    if (
      serializedPagewebError.resultCode ===
      ApiStatusCodeVo.ItemAccessRestrictionCountryDenied
    ) {
      return (
        <Text className="text-theme-solid-100">
          {t('contenthome_first_ep_tab_unavailable_in_country')}
        </Text>
      );
    } else {
      return (
        <ErrorArea
          isMobile={isMobile}
          className={isMobile ? 'min-h-200pxr' : 'min-h-364pxr'}
        >
          <ErrorArea.LabelButton
            onClick={() => this.setState({error: undefined})}
          >
            {t('error_retry_button')}
          </ErrorArea.LabelButton>
        </ErrorArea>
      );
    }
  }
}
